export interface IAuth {
  username: string;
  password: string;
}

export class Auth implements IAuth {

    username: string;
    password: string;

    static reviver(key: string, value: any): any {
        return key === 'password' ? atob(value) : value;
    }

    static decode(json: string): Auth {
        if (json !== null && json !== '') {
            try {
                return JSON.parse(json, Auth.reviver);
            } catch (ex) {
                return null;
            }
        }

        return null;
    }

  encode(): string {
    return JSON.stringify(Object.assign({}, this, {
      password: btoa(this.password)
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth.ts